// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__YB6GV","textContainer":"style_textContainer__5vHFm"};